import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _get from 'lodash/get';

// services
import TEnvReader from '@tekion/tekion-base/readers/Env';
import createHTTP, { getDefaultHeader } from '@tekion/tekion-base/services/apiService';

// constants
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import STATUS_CODES from '@tekion/tekion-base/constants/apiStatusCodes';

// Components
import { toaster } from '../../../organisms/NotificationWrapper';
var handleBackendError = function handleBackendError() {
  var errorData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var errorMsg = _get(errorData, 'errorDetails.displayMessage');
  if (errorMsg) {
    toaster('error', errorMsg);
  }
};
var ERROR_HANDLERS = _defineProperty({}, STATUS_CODES.ERROR, handleBackendError);
var errorInterceptor = function errorInterceptor() {
  var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var statusCode = error.status;
  var handler = ERROR_HANDLERS[statusCode];
  if (handler) {
    handler(error.data);
  }
  return Promise.reject(error);
};
var Http = function Http() {
  var newAxioInstnace = createHTTP("".concat(TEnvReader.cmdsUrl(process.env), "api/"));
  newAxioInstnace.interceptors.response.use(undefined, errorInterceptor);
  return {
    get: function get(url, data) {
      return newAxioInstnace({
        method: 'GET',
        headers: _objectSpread({}, getDefaultHeader()),
        url: url,
        params: data
      });
    }
  };
};
export default Http();